import { render } from "./GaleriaEditable.vue?vue&type=template&id=6a4d6893&scoped=true"
import script from "./GaleriaEditable.vue?vue&type=script&lang=js"
export * from "./GaleriaEditable.vue?vue&type=script&lang=js"

import "./GaleriaEditable.vue?vue&type=style&index=0&id=6a4d6893&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4d6893"]])

export default __exports__